module.exports = __webpack_public_path__ + "static/icon-diagram-ebbc29b2bb158b9898782d9126090484.png";